export default {
    name: 'OfflineNotification'
};
